import { z } from 'zod';
import { accountMapSchema } from './account';
import { periodicLedgerDataSchema } from './periodic_ledger_data';

const bookYearMetadataSchema = z.object({
  accountMap: accountMapSchema,
  periodicData: periodicLedgerDataSchema,
});
type BookYearMetadata = z.infer<typeof bookYearMetadataSchema>;

export { bookYearMetadataSchema, type BookYearMetadata };
